module.exports = __webpack_public_path__ + "static/media/ico-lideres.e2d8df79.svg";